/**
 * es-ES translations for the QR Phone resources (formal register)
 */

export const qrphoneResourcesEs = {
  clients: {
    name: 'Cliente |||| Clientes',
    fields: {
      full_name: 'Nombre',
      email: 'Correo electrónico',
      password: 'Contraseña',
      company_name: 'Empresa',
      contact_no: 'Teléfono',
      plan_id: 'Plan',
      status: 'Estado',
    },
    plan_help:
      'Seleccione un plan. Sin un plan asignado, el cliente no podrá iniciar sesión.',
    activation_note:
      'Se enviará un correo electrónico al cliente para que establezca su contraseña y acceda. No es necesario asignar ninguna contraseña aquí.',
  },
  signupRequests: {
    name: 'Solicitud de alta |||| Solicitudes de alta',
    fields: {
      full_name: 'Nombre y apellidos',
      email: 'Correo electrónico',
      company_name: 'Empresa',
      contact_no: 'Teléfono',
      plan_id: 'Plan solicitado',
      created_at: 'Fecha de solicitud',
      state: 'Estado',
      notes: 'Notas',
    },
    states: {
      pending: 'Pendiente',
      converted: 'Convertida',
      rejected: 'Rechazada',
    },
    actions: {
      convert: 'Convertir en cliente',
      reject: 'Rechazar',
    },
    confirm: {
      reject_title: 'Rechazar la solicitud',
      reject_content:
        '¿Desea rechazar esta solicitud? La decisión es definitiva y no podrá deshacerse.',
    },
    notifications: {
      converted: 'Solicitud convertida en cliente correctamente',
      rejected: 'Solicitud rechazada correctamente',
      already_decided:
        'Otra persona ya había resuelto esta solicitud. Se ha actualizado la lista.',
      decision_failed: 'No se ha podido resolver la solicitud. Inténtelo de nuevo.',
      convert_orphan:
        'El cliente se ha creado, pero no se ha podido marcar la solicitud como convertida. Revísela en la lista.',
    },
  },
  orgManagers: {
    name: 'Gestor de organización |||| Gestores de organización',
    fields: {
      full_name: 'Nombre',
      email: 'Correo electrónico',
      password: 'Contraseña',
      contact_no: 'Teléfono',
      organization_id: 'Organización',
      organizations_array: 'Organizaciones',
      status: 'Estado',
    },
  },
  connections: {
    name: 'Conexión |||| Conexiones',
    fields: {
      user_name: 'Usuario',
      user_email: 'Correo electrónico',
      login_connection_date: 'Inicio de sesión',
      login_connection_device_os: 'Dispositivo',
      logout_connection_date: 'Cierre de sesión',
    },
  },
  admins: {
    name: 'Administrador |||| Administradores',
    fields: {
      full_name: 'Nombre',
      email: 'Correo electrónico',
      password: 'Contraseña',
      contact_no: 'Teléfono',
      status: 'Estado',
      last_login: 'Último acceso',
    },
  },
  qrUserDetails: {
    name: 'Campo del llamante |||| Campos del llamante',
    types: {
      text: 'Texto',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      number: 'Número',
    },
    fields: {
      field_name: 'Nombre del campo',
      type: 'Tipo',
    },
  },
  plans: {
    name: 'Plan |||| Planes',
    stripe_note: 'Los cambios de nombre o precio se sincronizan automáticamente con la pasarela de pago.',
    types: {
      individual: 'Individual',
      company: 'Empresa',
    },
    durations: {
      monthly: 'Mensual (30 días)',
      yearly: 'Anual (365 días)',
    },
    fields: {
      name: 'Nombre',
      description: 'Descripción',
      tagline: 'Eslogan',
      price: 'Precio (€)',
      plan_type: 'Tipo',
      duration: 'Duración',
      is_qr_type_static: 'Permite QR estáticos',
      is_qr_type_dynamic: 'Permite QR dinámicos',
      static_qr_limit: 'Límite QR estáticos',
      dynamic_qr_limit: 'Límite QR dinámicos',
      staff_member_limit: 'Límite de personal',
      modules: 'Módulos',
    },
  },
  transactions: {
    name: 'Pago |||| Pagos',
    status: {
      paid: 'Pagado',
      pending: 'Pendiente',
    },
    fields: {
      created_on: 'Fecha',
      user_id: 'Cliente',
      plan_id: 'Plan',
      plan_price: 'Importe',
      plan_start_date: 'Inicio del plan',
      plan_end_date: 'Fin del plan',
      payment_status: 'Estado del pago',
      is_active: 'Activo',
    },
  },
  organizations: {
    name: 'Organización |||| Organizaciones',
    fields: {
      client_id: 'Cliente propietario',
      password: 'Contraseña',
      full_name: 'Nombre',
      email: 'Correo electrónico',
      company_name: 'Empresa',
      contact_no: 'Teléfono',
      address: 'Dirección',
      city: 'Ciudad',
      postal_code: 'Código postal',
      status: 'Estado',
      createdAt: 'Fecha de alta',
    },
  },
  staff: {
    name: 'Miembro del personal |||| Personal',
    plan_limit_note: 'El alta de personal está sujeta al límite de miembros del plan contratado.',
    activation_note:
      'Se enviará un correo electrónico a la persona para que establezca su contraseña y acceda. No es necesario asignar ninguna contraseña aquí.',
    invite: {
      button: 'Invitar',
      title: 'Invitar usuario a una organización',
      send: 'Enviar invitación',
      success: 'Invitación enviada correctamente',
    },
    remove_org: {
      button: 'Quitar de una organización',
      title: 'Quitar de la organización',
      success: 'Miembro quitado de la organización correctamente',
    },
    fields: {
      password: 'Contraseña',
      full_name: 'Nombre',
      email: 'Correo electrónico',
      contact_no: 'Teléfono',
      organization_id: 'Organización',
      department_id: 'Horario',
      status: 'Estado',
      last_login: 'Último acceso',
      createdAt: 'Fecha de alta',
    },
  },
  departments: {
    name: 'Horario |||| Horarios',
    fields: {
      name: 'Nombre',
      description: 'Descripción',
      organization_id: 'Organización',
      start_shift: 'Inicio de turno',
      end_shift: 'Fin de turno',
      weekdays: 'Días de la semana',
      'user.full_name': 'Creado por',
    },
  },
  userGroupOrganization: {
    name: 'Asignación de personal |||| Asignaciones de personal',
    fields: {
      organization_id: 'Organización',
      group_id: 'Horario',
      staff_id: 'Personal',
      is_primary: 'Principal',
      'organization.full_name': 'Organización',
      'department.name': 'Horario',
      'staff.full_name': 'Personal',
    },
  },
  qrcodes: {
    name: 'Código QR |||| Códigos QR',
    plan_limit_note: 'La creación de códigos QR está sujeta a los límites del plan contratado (estáticos y dinámicos).',
    types: {
      static: 'Estático',
      dynamic: 'Dinámico',
    },
    actions: {
      download: 'Descargar imagen',
    },
    no_image: 'Este código QR no tiene imagen generada.',
    department_help:
      'El código QR llama al personal asignado a estos horarios (según el día y la franja horaria). Las asignaciones de personal a horarios se gestionan en "Asignación de personal".',
    staffs_help:
      'Personal que recibe la llamada directamente, además del asignado a los horarios.',
    default_staff_help:
      'Solo se pueden elegir agentes con un dispositivo activo capaz de atender llamadas. El personal por defecto recibe la llamada cuando no responde el personal asignado.',
    default_staff_warning:
      'El personal por defecto seleccionado no puede atender llamadas (no es un agente con dispositivo activo). Este kiosco podría no recibir llamadas.',
    default_staff_cannot_answer_suffix: 'no puede atender llamadas',
    show_callback_form_help:
      'Muestra un formulario de contacto a quien llama cuando no hay personal disponible para atenderle. Tiene sentido cuando la persona escanea el código desde su propio teléfono, pero no en un punto de atención sin teclado, donde conviene desactivarlo.',
    fields: {
      staffs: 'Personal asignado',
      deptArr: 'Horarios',
      no_expiry: 'Sin caducidad',
      enabledDirectCall: 'Llamada directa',
      showCallbackForm: 'Formulario de contacto',
      public_link: 'Enlace público',
      qr_name: 'Nombre',
      type: 'Tipo',
      status: 'Estado',
      organization_id: 'Organización',
      department_id: 'Horarios',
      default_staff_id: 'Personal por defecto',
      default_staff_name: 'Personal por defecto',
      qr_start_time: 'Inicio de validez',
      qr_end_time: 'Fin de validez',
      createdAt: 'Fecha de creación',
    },
  },
  callDetails: {
    name: 'Llamada |||| Historial de llamadas',
    filters: {
      q: 'Buscar',
      date_from: 'Desde',
      date_to: 'Hasta',
      organization: 'Organización',
      staff: 'Personal',
      status: 'Estado',
    },
    connection: {
      yes: 'Atendida',
      no: 'No atendida',
    },
    status: {
      CALL_ENDED: 'Finalizada',
      ANSWER_CALL: 'Atendida',
      MISSED_CALL: 'Perdida',
      NO_ANSWER: 'Sin respuesta',
      CALL_REJECTED: 'Rechazada',
      REJTD: 'Rechazada (dispositivo)',
      QUEUED: 'En cola',
      QUEUE_TIMEOUT: 'Tiempo de cola agotado',
      STAFF_UNAVAILABLE: 'Personal no disponible',
      CONNECTION_ERROR: 'Error de conexión',
    },
    export: {
      empty: 'No hay datos que exportar con los filtros actuales',
      capped: 'La exportación se limita a las 1000 llamadas más recientes',
    },
    fields: {
      caller: 'Llamante',
      start_time: 'Fecha y hora',
      end_time: 'Fin',
      user_info: 'Llamante',
      user_name: 'Atendida por',
      user_id: 'Atendida por',
      organization_id: 'Organización',
      qrcode_id: 'Código QR',
      callstatus: 'Estado',
      duration: 'Duración',
      booking_id: 'Reserva',
      isCallConnected: 'Conectada',
    },
  },
};

export default qrphoneResourcesEs;
